import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';

interface PageErrorStateProps {
  heading?: string;
  description?: string;
  onRetry?: () => void;
  isRetrying?: boolean;
}

const PageErrorState = ({
  heading = 'Unable to load',
  description = 'We encountered a problem loading this page. Please try again.',
  onRetry,
  isRetrying = false,
}: PageErrorStateProps) => (
  <ChakraFlex
    alignItems="center"
    data-testid="page-error-state"
    direction="column"
    gap="16px"
    height="100%"
    justifyContent="center"
    role="alert"
  >
    <Text color="neutral.secondary" variant="h5">
      {heading}
    </Text>
    <Text
      color="neutral.secondary"
      maxWidth="400px"
      textAlign="center"
      variant="caption"
    >
      {description}
    </Text>
    {onRetry && (
      <FireflyButton
        id="page-error-retry-button"
        isLoading={isRetrying}
        leftIcon={FAIconName.arrowsRotateRegular}
        onClick={onRetry}
        size="small"
        variant="secondary"
      >
        Retry
      </FireflyButton>
    )}
  </ChakraFlex>
);

export default PageErrorState;
